export default __webpack_public_path__ + "b886e89c8feac7c532a19b14e75fee3a.png";